export const MplusPopUps = {
  availableInfo: {
    key: 'availableInfo',
    title: 'mplus.mplus_avalible_info_title',
    description: 'mplus.mplus_avalible_info_desc',
  },
  unavailableInfo: {
    key: 'unavailableInfo',
    title: 'mplus.mplus_not_avalible_info_title',
    description: `mplus.mplus_not_avalible_info_desc`,
  },
  cashback: {
    key: 'cashback',
    title: 'mplus.mplus_cashback_info_title',
    description: 'mplus.mplus_cashback_info_desc',
  },
  eachMonthPayInfo: {
    key: 'eachMonthPayInfo',
    title: 'mplus.mplus_each_month_pay_info_title',
    description: 'mplus.mplus_each_month_pay_info_desc',
  },
  witchDayPayInfo: {
    key: 'witchDayPayInfo',
    title: 'mplus.mplus_day_pay_info_title',
    description: 'mplus.mplus_day_pay_info_desc',
  },
} as const

export type MplusPopUpsTypes = keyof typeof MplusPopUps
